// Validador para el input de tipo Cif
// Este validador comprobará que el input introducido es un Cif (Identificador empresa), caso España(letra delante): L23432345

import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CifValidators {
    public static readonly validators = {
        AE: {
            regExp: /^\d{15}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        AM: {
            regExp: /^\d{9}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        EE: {
            regExp: /^EE\d{9}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        EG: {
            regExp: /^\d{14}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        ES: {
            regExp: /^([A-HJ-NP-SU-W])(\d{7})([\dA-J])$/,
            parse(result) {
                return {
                    number: result[0],
                    controlNumber: result[2],
                    controlKey: result[1],
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        FI: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        GE: {
            regExp: /^(\d{9}|\d{11})$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        HU: {
            regExp: /^\d{8}-\d-\d{2}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        IC: {
            regExp: /^([A-HJNP-SU-W])(\w{8})$/,
            parse(result) {
                return {
                    number: result[0],
                    controlNumber: result[2],
                    controlKey: result[1],
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        IT: {
            regExp: /^([A-Za-z]{6}[\dL-NP-Vl-np-v]{2}[A-EHLMPR-Ta-ehlmpr-t][\dL-NP-Vl-np-v]{2}[A-Za-z][\dL-NP-Vl-np-v]{3}[A-Za-z])$|^(\d{11})$|^(IT\d{11})$/,
            parse(result) {
                return {
                    number: result[0],
                    controlNumber: result[2],
                    controlKey: result[1],
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        JO: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        KW: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        LB: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        LT: {
            regExp: /^\d{9,12}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        LV: {
            regExp: /(^LV\d{11}$)|(^\d{11}$)/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        MA: {
            regExp: /^(\d{15})$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        MX: {
            regExp: /^((([&A-ZÑ]{3})(\d{2})(0[13578]|1[02])((0[1-9]|[12]\d)|3[01])([\dA-Z]{3}))$|^(([&A-ZÑ]{3})(\d{2})(0[13-9]|1[0-2])((0[1-9]|[12]\d)|30)([\dA-Z]{3}))$|^(([&A-ZÑ]{3})([02468][048]|[13579][26])02(0[1-9]|[12]\d)([\dA-Z]{3}))$|^(([&A-ZÑ]{3})(\d{2})02(0[1-9]|1\d|2[0-8])([\dA-Z]{3})))$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        NL: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        RU: {
            regExp: /^\d{10}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        RS: {
            regExp: /^\d{9}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => {
                return true;
            },
        },
        SA: {
            regExp: /^(\d{15})$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        TR: {
            regExp: /(^\d{10})$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
    };

    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    static createValidator(countryCode: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (countryCode == null) {
                return;
            }

            const validator = this.validators[countryCode];

            const input = control.value?.toString();

            const result = validator.regExp.exec(input);

            if (result && validator.parse(result).isValid()) {
                return;
            }
            return { pattern: true };
        };
    }
}
